module.exports = __webpack_public_path__ + "static/media/bunu_walking.fbcc80f3.gif";